export const StatisticsType = {
  TPsStatistics: "tpsStatistics",
  JobsStatistics: "jobsStatistics",
  UsersStatistics: "usersStatistics",
  PublishersStatistics: "publishersStatistics",
};
